import { AdminPermission } from '../../../services/commons/Me';
import { AdminPermissions, AdminPermissionsOnModule } from '../../../services/commons/Permissions/AdminPermissions';
import { PermissionsAbilityHelper } from '../../../services/commons/Permissions/PermissionsAbilityHelper';
import { PermissionType } from '../../../services/commons/Permissions/PermissionType';

export class ContactsPermissions {
    public static CONTACTS_CODE = 'Directories';

    public static Admin: AdminPermissionsOnModule = {};

    public static initializeContactsAdminPermissions = (perms: Array<AdminPermission> = []) => {
        const permsOnContacts = AdminPermissions.filter(perms, ContactsPermissions.CONTACTS_CODE);

        const canWrite = AdminPermissions.has(PermissionType.Write, permsOnContacts);
        ContactsPermissions.Admin = {
            canRead: true,
            canExport: true,
            canList: true,
            canCreate: canWrite,
            canImport: canWrite,
            canSave: canWrite,
            canRemove: canWrite,
            canEditName: canWrite,
            canEditExternalReference: canWrite,
        }
        PermissionsAbilityHelper.logPermissions('Contacts', ContactsPermissions.Admin);
    };
}
